/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { RevisionsRequestBuilderNavigationMetadata, type RevisionsRequestBuilder } from './revisions/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/pending/{fileId}
 */
export interface WithFileItemRequestBuilder extends BaseRequestBuilder<WithFileItemRequestBuilder> {
    /**
     * The revisions property
     */
    get revisions(): RevisionsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithFileItemRequestBuilderUriTemplate = "{+baseurl}/files/pending/{fileId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithFileItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithFileItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    revisions: {
        navigationMetadata: RevisionsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
